var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_10157819",
    clipPath: "url(#clip0_1172_3138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.8865 0.5H104.072C108.672 0.5 112.401 4.22891 112.401 8.82852V89.6926L92.7251 97.148L83.1398 120.5H40.8867L26.8819 117.565L14.6316 58.6892L26.3712 3.48688L40.8865 0.5Z",
    fill: "#FFF1CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.7034 108.219V12.7805C33.7034 7.50898 36.6 2.91664 40.8865 0.5H15.9277C11.328 0.5 7.59914 4.22891 7.59914 8.82852V112.171C7.59914 116.771 11.328 120.5 15.9277 120.5H40.8865C36.6 118.083 33.7034 113.491 33.7034 108.219Z",
    fill: "#FCE3A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M91.4684 89.6924C86.8685 89.6924 83.1398 93.4213 83.1398 98.0209V120.5L112.401 89.6924H91.4684Z",
    fill: "#FCE3A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.0283 47.3889C31.771 47.3889 33.9945 45.1655 33.9945 42.4227C33.9945 39.68 31.771 37.4565 29.0283 37.4565C26.2855 37.4565 24.0621 39.68 24.0621 42.4227C24.0621 45.1655 26.2855 47.3889 29.0283 47.3889Z",
    fill: "#29CE69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.0283 65.466C31.771 65.466 33.9945 63.2426 33.9945 60.4999C33.9945 57.7571 31.771 55.5337 29.0283 55.5337C26.2855 55.5337 24.0621 57.7571 24.0621 60.4999C24.0621 63.2426 26.2855 65.466 29.0283 65.466Z",
    fill: "#FD5C6F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M29.0283 83.5437C31.771 83.5437 33.9945 81.3202 33.9945 78.5775C33.9945 75.8348 31.771 73.6113 29.0283 73.6113C26.2855 73.6113 24.0621 75.8348 24.0621 78.5775C24.0621 81.3202 26.2855 83.5437 29.0283 83.5437Z",
    fill: "#FD5C6F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.8234 28.9058C43.9351 28.9058 47.2683 26.2514 47.2683 22.9771C47.2683 19.7027 43.9351 17.0483 39.8234 17.0483C35.7116 17.0483 32.3784 19.7027 32.3784 22.9771C32.3784 26.2514 35.7116 28.9058 39.8234 28.9058Z",
    fill: "#FFA1AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M80.1766 28.9058C84.2884 28.9058 87.6216 26.2514 87.6216 22.9771C87.6216 19.7027 84.2884 17.0483 80.1766 17.0483C76.0649 17.0483 72.7317 19.7027 72.7317 22.9771C72.7317 26.2514 76.0649 28.9058 80.1766 28.9058Z",
    fill: "#FFA1AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M43.868 42.4226C43.868 43.4227 44.6787 44.2334 45.6787 44.2334H95.9379C96.9382 44.2334 97.7487 43.4227 97.7487 42.4226C97.7487 41.4225 96.938 40.6118 95.9379 40.6118H45.6787C44.6787 40.6118 43.868 41.4225 43.868 42.4226Z",
    fill: "#475066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M95.9379 58.689H45.6787C44.6787 58.689 43.868 59.4997 43.868 60.4997C43.868 61.4998 44.6787 62.3105 45.6787 62.3105H95.9379C96.9382 62.3105 97.7487 61.4998 97.7487 60.4997C97.7487 59.4997 96.9382 58.689 95.9379 58.689Z",
    fill: "#475066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M95.9379 76.7661H45.6787C44.6787 76.7661 43.868 77.5768 43.868 78.5769C43.868 79.577 44.6787 80.3877 45.6787 80.3877H95.9379C96.9382 80.3877 97.7487 79.577 97.7487 78.5769C97.7487 77.577 96.9382 76.7661 95.9379 76.7661Z",
    fill: "#475066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M45.9729 17.1969V14.2996C45.9729 13.2995 45.1622 12.4888 44.1621 12.4888C43.162 12.4888 42.3513 13.2995 42.3513 14.2996V17.1969C42.3513 18.197 43.162 19.0077 44.1621 19.0077C45.1622 19.0077 45.9729 18.197 45.9729 17.1969Z",
    fill: "#475066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M60 20.8926C62.1237 20.8926 64.1433 19.9729 65.5409 18.3693C66.198 17.6153 66.1193 16.4713 65.3655 15.8144C64.6113 15.1574 63.4671 15.2359 62.8106 15.9897C62.1012 16.8039 61.077 17.2708 60.0002 17.2708C58.9237 17.2708 57.8993 16.8039 57.1898 15.9897C56.5327 15.2357 55.3889 15.1574 54.6349 15.8144C53.8809 16.4716 53.8024 17.6153 54.4596 18.3693C55.8567 19.9729 57.8763 20.8926 60 20.8926Z",
    fill: "#475066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M73.0397 18.927C74.04 18.927 74.8505 18.1163 74.8505 17.1162C74.8505 16.2633 75.5445 15.5693 76.3973 15.5693C77.2502 15.5693 77.9442 16.2633 77.9442 17.1162C77.9442 18.1163 78.7549 18.927 79.755 18.927C80.7551 18.927 81.5658 18.1163 81.5658 17.1162C81.5658 14.2664 79.2473 11.9478 76.3973 11.9478C73.5473 11.9478 71.2289 14.2664 71.2289 17.1162C71.2287 18.116 72.0394 18.927 73.0397 18.927Z",
    fill: "#475066"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1172_3138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.2b77b14b68ae54bc44e58c5baab6e3a7.svg";
export { ForwardRef as ReactComponent };